let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4FQLY")).then(() => parcelRequire('dxZWk'));